// LOCALIZATION

export enum Locale {
  DE = "de_DE",
  EN = "en_GB",
}

export interface LocalizedString {
  de_DE: string;
  en_GB: string;
}

// PARTICIPANT

export enum ParticipantGender {
  Female = "W",
  Male = "M",
  Divers = "D",
  Unknown = "A",
}

export interface ParticipantPic {
  url: string;
  altText?: string;
}

export enum ParticipantRole {
  Eventmanager = "Eventmanager",
}

export interface Participant {
  partId: number;
  partLanguage: string; // should be Locale
  expoSiteLink: LocalizedString;
  partGender: ParticipantGender;
  partName: string;
  partSurname: string;
  partEmail1: string;
  partEmail1TypeMain: boolean;
  partEmail2: string;
  partEmail2TypMain: boolean;
  partTimezoneOffset: number;
  corporation: Corporation[];
  partCompany2: string;
  partIndustry: string;
  partProfPosition: string;
  partResponsibility: string;
  partFunction: string;
  classification: { classificationId: number }[];
  partPic: ParticipantPic;
  partRole: ParticipantRole[];
}

// CLASSIFICATION

export interface Classification {
  classificationId: number;
  classificationTitle: LocalizedString;
  expert: Participant;
}

// CORPORATION

export interface Corporation {
  corpId: number;
  expoSiteLink: LocalizedString;
  corpName: LocalizedString;
  corpLogo: ParticipantPic;
  experts: Participant[];
  classification: Classification[];
}

export interface InvitedExpert {
  email: string;
}

export interface Exhibitor extends Corporation {
  invitedExperts: InvitedExpert[];
}

// MEETING

export enum MeetingStatus {
  Open = "OPEN",
  Closed = "CLOSED",
  Cancelled = "CANCELLED",
  Omitted = "OMITTED",
}

export interface Meeting {
  id: number;
  product: Classification;
  participant: Participant;
  expert: Participant;
  start: string;
  end: string;
  request?: string;
  status: MeetingStatus;
}

// EVENT

export interface EventPic {
  url: string;
  altText: string;
}

export interface Event {
  eventId: number;
  expoSiteLink: LocalizedString;
  eventTitle: LocalizedString;
  eventDay: string;
  eventBegin: string;
  eventPic: EventPic;
}

// FAVOURITE

export enum CategoryTag {
  Event = "EVENT",
  Corporation = "CORPORATION",
  Participant = "PARTICIPANT",
}

export interface Favourite {
  corporation: Corporation[];
  participant: Participant[];
  event: Event[];
}

// EXTERNAL DOCUMENT

export interface ExternalDocument {
  id: number;
  partId: number;
  externalUrl: string;
  metaTitle?: string;
  metaDescription?: string;
  accessDate: string;
}
